module.exports = __webpack_public_path__ + "img/no_task888.44cdcde3.png";